import { z } from 'zod'

export const UI_BLOCKERS = Object.freeze({
  FEED_MEMBERS_LIST: 'feed_members_list',
  MEMBER_SUMMARY: 'member_summary',
  MEMBER_CHART: 'member_chart',
  MEMBER_BANNER: 'member_banner',
  MEMBER_TASKS: 'member_tasks',
  MEMBER_CALENDAR: 'member_calendar',
  RENDER_MEMBER_FEED: 'render_member_feed', // For logic errors, not specific API failures
  RENDER_CHAT_IFRAME: 'render_chat_iframe',
  ERROR_ALERT: 'error_alert',
} as const)

const UI_BLOCKERS_KEYS = Object.values(UI_BLOCKERS) as [string, ...string[]]

export const uiBlockerSchema = z.object({
  blocker: z.enum(UI_BLOCKERS_KEYS),
  request: z.string().optional(),
  programUuid: z.string().optional(),
})
